<template>
  <div class="report-center-wrap">
    <div class="page-header">
      <div class="flex-row-between-center title-top">
        <div class="title-left">
          订单报备
        </div>
        <div>
          <span class="el-icon-warning c-red"></span>
          请于每月最后一个工作日前发起报备，发起报备后平台预计
          <span class="c-red">1个工作日</span>反馈结果，请您耐心等待
        </div>

        <div class="apply-btn" @click="goCreate">去报备</div>
      </div>
      <div class="top-info">
        针对部分订单受影响的情况进行报备，报备审核通过后对指定的订单生效。
      </div>
    </div>
    <div class="gray-bg"></div>
    <el-form
      ref="searchForm"
      label-position="right"
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-bottom: 10px"
    >
      <el-form-item label="申请ID">
        <el-input v-model="searchForm.ids" />
      </el-form-item>

      <el-form-item label="状态">
        <el-select
          v-model="searchForm.status"
          clearable
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="延迟发货原因" label-width="120px">
        <el-select
          v-model="searchForm.delay_reason"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in reasonList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发起时间">
        <el-date-picker
          v-model="searchForm.date"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px;"
        />
      </el-form-item>
      <!-- <div class="flex-row-end-center"> -->
      <el-form-item>
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
        <el-button
          type="primary"
          size="small"
          style="background:#fff;color:#FF6224;border-color:#ccc;color:#666;"
          @click="resetForm"
          >重置
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="onExport()"
          :loading="exportLoading"
        >
          导出
        </el-button>
      </el-form-item>
      <!-- </div> -->
    </el-form>
    <div style="padding-top: 8px;">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%; text-align: center"
        size="mini"
        @select="handleSelect"
        @select-all="handleSelectAll"
        :row-key="row => row.id"
      >
        >
        <el-table-column type="selection" />
        <el-table-column prop="id" label="申请ID" width="80" />
        <el-table-column prop="report_type_str" label="报备类型" />
        <el-table-column
          prop="report_reason_str"
          label="延迟发货原因"
          width="180"
        />
        <el-table-column
          prop="report_detailed_reason"
          label="备注"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="status_str" label="报备状态" />
        <el-table-column prop="created_at" label="发起时间" width="180" />
        <el-table-column prop="review_time" label="审核时间" width="180" />
        <el-table-column
          prop="review_comment"
          label="审核备注"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <span class="opt-btn" @click="goDetail(scope.row.id)">查看</span>
            <span
              class="opt-btn"
              style="margin:0 8px"
              @click="reject(scope.row.id)"
              v-if="scope.row.status == 2"
            >
              撤消
            </span>
            <span
              class="opt-btn"
              @click="goEdit(scope.row)"
              v-if="scope.row.status == 1 || scope.row.status == 2"
              >修改</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.page"
      :page-sizes="[10, 20, 50, 100, 200, 500]"
      :page-size="queryInfo.page_size"
      layout="total,sizes, prev, pager, next,jumper"
      :total="queryInfo.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {
  getReportLists,
  getDelayEnum,
  getStatusEnum,
  cancelReportApply
} from "@/models/orderReportModel";
import shopOpen from "@/assets/img/report/shop-open.png";
import shopClose from "@/assets/img/report/shop-close.png";
import { postExport } from "@/utils/utils";
import moment from "moment";
export default {
  data() {
    return {
      img: { shopOpen, shopClose },
      queryInfo: {
        page: 1,
        page_size: 10,
        total: 0 //总数
      }, // 分页配置数据
      searchForm: {
        ids: undefined,
        delay_reason: undefined,
        status: undefined,
        date: undefined,
        page: 1,
        page_size: 10
      },
      tableData: [], // 表格数据
      loading: false,
      visible: false, //休店弹框
      reasonList: [],
      statusList: [],
      selectionRows: [],
      exportLoading: false
    };
  },
  created() {
    this.getEnum();
    this.getList(this.searchForm); //获取列表
  },
  methods: {
    // 枚举(原因、状态)
    getEnum() {
      getDelayEnum()
        .then(res => {
          let arr = [];
          if (res) {
            for (const key in res) {
              if (Object.hasOwnProperty.call(res, key)) {
                arr.push({ label: res[key], value: key });
              }
            }
            this.reasonList = arr;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
      getStatusEnum()
        .then(res => {
          let arr = [];
          if (res) {
            for (const key in res) {
              if (Object.hasOwnProperty.call(res, key)) {
                arr.push({ label: res[key], value: key });
              }
            }
            this.statusList = arr;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //获取数据列表
    getList(param) {
      const searchParams = param || this.searchForm;
      const params = {
        ...searchParams,
        // export_source: 0,
        delay_reason: searchParams.delay_reason,
        status: searchParams.status ? searchParams.status.join(",") : undefined,
        page: searchParams.page || this.queryInfo.page || 1,
        page_size: searchParams.page_size || this.queryInfo.page_size || 10
      };
      if (params.date && params.date.length == 2) {
        params.start_time = moment(params.date[0]).format("YYYY-MM-DD");
        params.end_time = moment(params.date[1]).format("YYYY-MM-DD");
        delete params.date;
      }
      getReportLists(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 重置
    resetForm() {
      const params = {
        ids: undefined,
        delay_reason: undefined,
        status: undefined,
        date: undefined,
        page: 1,
        page_size: 10
      };
      this.searchForm = params;
      this.queryInfo = {
        ...this.queryInfo,
        page: 1,
        page_size: 10
      };
      this.getList({ ...params });
    },

    // 改变pagesize
    handleSizeChange(value) {
      this.queryInfo.page_size = value;
      this.searchForm.page_size = value;
      const params = { ...this.searchForm, page_size: value };
      this.getList(params);
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.searchForm.page = value;
      const params = { ...this.searchForm, page: value };
      this.getList(params);
    },
    // 导出
    onExport() {
      const {
        ids,
        delay_reason,
        status,
        date,
        page,
        page_size
      } = this.searchForm;
      const isSearchParamsNull =
        !ids && !delay_reason && (!status || !status.length) && !date;
      if (this.selectionRows.length == 0 && isSearchParamsNull) {
        this.$message.warning("请至少勾选一条数据或输入一个查询条件！");
        return false;
      }
      let postUrl = `${echarthostname}/system/shop/shippingdelaylistforshop?token=${localStorage.getItem(
        "token"
      )}&shop_id=${localStorage.getItem("shop_id")}&export_source=1`;
      if (this.selectionRows.length > 0) {
        const ids = this.selectionRows.map(item => item.id);
        postUrl += `&ids=${ids.join(",")}`;
      } else {
        postUrl += `&delay_reason=${delay_reason}&status=${
          status ? status.join(",") : undefined
        }&page=${page || this.queryInfo.page || 1}&page_size=${page_size ||
          this.queryInfo.page_size ||
          10}`;
        if (date && date.length == 2) {
          postUrl += `&start_time=${moment(date[0]).format(
            "YYYY-MM-DD"
          )}&end_time=${moment(date[1]).format("YYYY-MM-DD")}`;
        }
      }
      this.exportLoading = true;
      postExport(postUrl, "报备单列表", null, "GET")
        .then(res => {
          this.exportLoading = false;
          this.$message({ type: "success", message: "导出成功" });
        })
        .catch(err => {
          this.exportLoading = false;
          // this.$message({ type: "error", message: err.message });
        });
    },

    //
    handleSelect(val) {
      this.selectionRows = val;
    },
    handleSelectAll(val) {
      this.selectionRows = val;
    },
    // 查看详情
    goDetail(id) {
      this.$router.push({
        name: "reportCreate",
        params: { id, type: "check" }
      });
    },

    // 去报备
    goCreate() {
      this.$router.push({
        name: "reportCreate",
        params: { type: "create" }
      });
    },
    // 撤消申请
    reject(id) {
      this.$confirm("确定要撤消申请吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.handleReject(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤消"
          });
        });
    },
    handleReject(id) {
      // console.log("撤消-id-------", id);
      cancelReportApply({ id })
        .then(res => {
          this.getList(this.searchForm);
          this.$message({
            message: "撤消成功！",
            type: "success"
          });
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 去修改
    goEdit(row) {
      this.$router.push({
        name: "reportCreate",
        params: { ...row, type: "edit" }
      });
    }
  }
};
</script>
<style lang="scss">
.report-center-wrap {
  .page-header {
    margin: 8px 0 32px;
    font-size: 14px;
    .title-left {
      font-size: 16px;
      font-weight: bold;
      display: flex;
    }
    .title-top {
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }
  }
  .gray-bg {
    position: absolute;
    width: 100%;
    height: 14px;
    left: 0;
    background: #eee;
    top: 88px;
  }
  .apply-btn {
    border: 1px solid #ff6224;
    padding: 3px 12px;
    font-size: 13px;
    border-radius: 4px;
    color: #ff6224;
    margin-left: 24px;
    cursor: pointer;
  }
  .m-b-8 {
    margin-bottom: 8px;
  }
  .c-red {
    color: #ff4d4f;
  }
  .top-info {
    margin: 14px auto;
  }
  .opt-btn {
    cursor: pointer;
    color: #ff6224;
  }
}
.report-center-form .el-form-item {
  margin-bottom: 10px;

  .c-red {
    color: #ff4d4f;
  }
}
.report-center-dialog {
  .el-form-item__label {
    text-align: right !important;
  }
  .checked-tips {
    position: absolute;
    top: 0;
    left: 64px;
  }
}
/deep/.el-table tr {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/reportCenter/index.vue